import { postData } from '../apiService'

export const toggleWishlistApi = async (bookId, navigate) => {
  const res = await postData(`BookWishlist/AddUpdateWishlist?bookId=${bookId}`, null, navigate);
  return res;
};